import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {StemDate} from "../../stem-core/time/Time";
import {ExternalAppConfig} from "./ExternalAppConfigStore";
import {UserProfile} from "./UserProfileStore";
import {Merchant} from "./MerchantStore";
import {field} from "../../stem-core/state/StoreField";
import {MerchantUser} from "./merchant/MerchantUserStore";

@globalStore
export class ExternalAppRequestInstance extends BaseStore("ExternalAppRequestInstance") {
    @field("ExternalAppConfig") app: ExternalAppConfig;
    @field(Date) createdAt: StemDate;
    @field("UserProfile") user: UserProfile;
    @field("Merchant") merchant: Merchant;
    @field(String) url: string;
    @field(String) method: string;
    @field(String) requestPayload: string;
    @field(Number) responseCode: number;
    @field(Number) responseElapsedMs: number;
    @field(String) responsePayload: string;
    @field(Object) extra: object;
    @field(String) contextType: string;
    @field(String) contextUid: string;
    @field(String) contextMethod: string;

    getMerchantUser(): MerchantUser | null {
        return MerchantUser.getFromObject(this);
    }

    getError(): string | null {
        try {
            const response = JSON.parse(this.requestPayload || "");
            if (response.error) {
                return response.error;
            }
        } catch (e) {
            if (this.responseCode !== 200) {
                return `Invalid response code ${this.responseCode}`;
            }
            return "Unparsable response";
        }
        return null;
    }
}
